import { render, staticRenderFns } from "./Flow_details.vue?vue&type=template&id=22991764&scoped=true"
import script from "./Flow_details.vue?vue&type=script&lang=js"
export * from "./Flow_details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22991764",
  null
  
)

export default component.exports